import { render, staticRenderFns } from "./IndexPageNoticeSection.vue?vue&type=template&id=b5cf20c0&"
import script from "./IndexPageNoticeSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageNoticeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports